export const TOKEN_KEY = 'protego_token';
export const USER_KEY = 'protego_user';

export function readStoredUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function readStoredToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function persistSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function displayName(user) {
  if (!user) return '';
  if (user.first_name?.trim()) return user.first_name.trim();
  if (user.name?.trim()) return user.name.trim().split(/\s+/)[0];
  if (user.email) return user.email.split('@')[0];
  return 'Account';
}
